module.exports = __webpack_public_path__ + "static/media/IMG-9582.fb45c3b4.jpg";